export enum ProcuraconContextType {
	RFX_PRE_SUBMISSION = 1,
}
